// Vendors
import * as PIXI from "pixi.js";
//@ts-ignore
global.PIXI = PIXI;
import "pixi-spine";
import Filter from 'bad-words';
// Style
import './assets/css/basic.scss';
import './assets/css/fonts.css';
// Main
import { Main } from 'screens/main';
// Services
import { FireBaseService, 
    ImagesPreloader, 
    MainMenuService, 
    LoaderService, 
    LanguageService, 
    SoundService, 
    QueryService, 
    UserService, 
    LoaderScreenService, 
    PopupsService,
    SignInService,
    SignUpService } from 'shared/services';
// Helpers
import { PreloaderHelper } from 'shared/helpers';
// Config
import { BuildConfig, BuildConfigTypes, HTMLImageConfig, MapConfig } from "shared/config";
// Storages
import { LanguageStorage } from "shared/storages";
import { Localizer } from "shared/localization";
import config from "config";

enum Orientations {
    portrait,
    landscape
};

class App {
    private mainMenuService: MainMenuService;
    private signInService: SignInService;
    private signUpService: SignUpService;
    private loaderScreenService: LoaderScreenService;

    constructor() {
        if(!config.debugPath) config.path = window.location.origin;
        this.init();
        // this._logVersion();
        this._setBuildConfig();
        this._setImagePath();
    }

    private _logVersion(): void {
        const date = new Date();
        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();

        console.log(`v: ${day}.${month}.${year}_${hours}_${minutes}`);
    }

    private _setImagePath(): void {
        const prefixes = BuildConfig.getConfig();
        const elements = HTMLImageConfig.pathToImages;

        for (const key in elements) {
            if (Object.prototype.hasOwnProperty.call(elements, key)) {
                const path = elements[key];
                const images = document.getElementsByClassName(key);

                for (let i = 0; i < images.length; i++) {
                    const image = images[i] as HTMLImageElement;
                    //@ts-ignore
                    image.src = `${subPath}/${path}`;
                }
            }
        }
    }

    private _setBuildConfig(): void {
        BuildConfig.currentConfigType = BuildConfigTypes.WithSubPath;
    }

    private defineOrienation(): void {
        const platform = window.navigator.platform;
        const oriental = document.getElementById('oriental');

        const isSafari = !window.screen.orientation;
        if (!isSafari) {
            if (window.screen.orientation.angle === 90 || window.screen.orientation.angle === 270) {
                oriental.style.visibility = 'visible';
            } else {
                oriental.style.visibility = 'hidden';
            }
        } else if (isSafari && platform !== 'MacIntel') {
            const query = window.matchMedia("(orientation: landscape)");
            query.addListener(this.orientationChange); // Or: query.addEventListener("change", orientationChange);
            this.orientationChange(query);
        }
    }

    private orientationChange(event) {
        const oriental = document.getElementById('oriental');
        if (event.matches) {
            // Landscape
            oriental.style.visibility = 'visible';
        }
        else {
            // Portrait
            oriental.style.visibility = 'hidden';
        }
    }

    private _checkIsShowRevards() {
        //@ts-ignore
        if (!isNeedToShowLoginAndRevard) {
            const levels = MapConfig.elements;

            for (let i = 0; i < levels.length; i++) {
                const level = levels[i];

                if (level.isRevard) {
                    levels.splice(i, 1);
                }
            }
        }
    }

    private processOrientationChange(orientation: Orientations): void {
        const oriental = document.getElementById('oriental');
        if (orientation === Orientations.landscape) {
            oriental.style.visibility = 'visible';
        } else {
            oriental.style.visibility = 'hidden';
        }
    }

    private toggleMusic(): void {
        const buttons = document.getElementsByClassName('toggleSound');
        const prefixes = BuildConfig.getConfig();

        for (let i = 0; i < buttons.length; i++) {
            const btn1 = buttons[i];

            btn1.addEventListener('click', () => {
                const user = JSON.parse(localStorage.getItem('mbny_game_user'));
                let state;
                if (!user) state = true;
                if (user) state = user.isMusicOn

                SoundService.offMusic(state);
                user.isMusicOn = !state;

                if (user.isMusicOn) {

                } else {

                }

                // for (let j = 0; j < btn.childNodes.length; j++) {
                //     const child = btn.childNodes[j] as any;

                //     if (child.nodeName === 'IMG' && !state) {
                //         //@ts-ignore
                //         child.src = `${prefixes.bgPrefix}${subPath}/assets/img/Sound_on.png`;
                //     }

                //     if (child.nodeName === 'IMG' && state) {
                //         //@ts-ignore
                //         child.src = `${prefixes.bgPrefix}${subPath}/assets/img/Sound_Icon.png`;
                //     }

                //     if (child.nodeName === 'SPAN' && !state) {
                //         child.innerText = LanguageService.getTranslation('loc_turn_sound_off');
                //     }

                //     if (child.nodeName === 'SPAN' && state) {
                //         child.innerText = LanguageService.getTranslation('loc_turn_sound_on');
                //     }
                // }

                for (let i = 0; i < buttons.length; i++) {
                    const btn = buttons[i];

                    for (let j = 0; j < btn.childNodes.length; j++) {
                        const child = btn.childNodes[j] as any;

                        if (child.nodeName === 'IMG' && !state) {
                            //@ts-ignore
                            child.src = `${prefixes.bgPrefix}${subPath}assets/img/Sound_on.png`;
                        }

                        if (child.nodeName === 'IMG' && state) {
                            //@ts-ignore
                            child.src = `${prefixes.bgPrefix}${subPath}assets/img/Sound_Icon.png`;
                        }

                        if (child.nodeName === 'SPAN' && !state) {
                            child.innerText = LanguageService.getTranslation('loc_turn_sound_off');
                        }

                        if (child.nodeName === 'SPAN' && state) {
                            child.innerText = LanguageService.getTranslation('loc_turn_sound_on');
                        }
                    }
                }


                localStorage.setItem('mbny_game_user', JSON.stringify(user));
            })
        }
    }

    private async init(): Promise<void> {
        const queryParams = QueryService.checkUrl();

        if (queryParams && queryParams.lan) {
            LanguageService.currentData.currentLanguage = queryParams.lan;
        }
        LanguageService.setDefaultLanguage();
        LanguageService.setCurrentLanguage();

        const userName = <HTMLInputElement>document.getElementById('userName_input');

        window.onbeforeunload = function (e) {
            e.preventDefault()
        }

        // && window.screen.orientation.angle === 90
        this.defineOrienation();

        document.getElementsByClassName('to_website')[0].addEventListener('pointerdown', () => {
            const win = window.open('https://www.maybelline.com', '_blank');
            win.focus();
        })

        window.addEventListener("orientationchange", () => {
            this.defineOrienation();
        });

        let user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const continueGame = JSON.parse(sessionStorage.getItem('token'));
        console.log('continueGame ::', continueGame);
        
        this.mainMenuService = new MainMenuService();
        const prefixes = BuildConfig.getConfig();

        this.signInService = new SignInService();
        this.signUpService = new SignUpService();

        const htmlImagesForPreload = [
            //@ts-ignore
            `${prefixes.bgPrefix}${subPath}assets/img/Bg_desktop.png`,
            //@ts-ignore
            `${prefixes.bgPrefix}${subPath}assets/img/Background.png`,
        ]
        FireBaseService.initApp();
        this.toggleMusic();
        ImagesPreloader.preloadImages(htmlImagesForPreload).then(async () => {
            this.loaderScreenService = new LoaderScreenService();
            await this.loaderScreenService.loadMainAssets();
            document.getElementsByTagName('body')[0].style.display = 'flex';
            const loader = this.loaderScreenService.loader;
            LoaderService.loadFont();
            LoaderService.awaitLoadCompleted(loader).then(async () => {
                //@ts-ignore
                if (!QueryService.checkUrl() && isNeedToShowLoginAndRevard) {
                    PopupsService.openSignInPopup();
                }

                //@ts-ignore
                if (!isNeedToShowLoginAndRevard) {
                    this._checkIsShowRevards();
                }
                if (queryParams && queryParams.userId) {

                    const querySnapshot = await UserService.getUserByMblnId(QueryService.userId);
                    querySnapshot.forEach(function (doc) {
                        // doc.data() is never undefined for query doc snapshots
                        user = doc.data();
                        user.id = doc.id;
                        user.isMusicOn = true;
                        localStorage.setItem('mbny_game_user', JSON.stringify(user));
                    });
                }

                try {
                    //@ts-ignore
                    if (mnygamelocale) {
                        //@ts-ignore
                        LanguageService.currentData.keys = mnygamelocale;
                    }
                } catch {

                }

                // if (queryParams && queryParams.lan) {
                //     LanguageService.currentData.currentLanguage = queryParams.lan;
                // }

                if (user && !user.isMusicOn) {
                    SoundService.offMusic(true);
                    SoundService.stopAll();
                }

                //@ts-ignore
                // console.log('isNeedToShowLoginAndRevard ::', showGameRegistration);
                
                if (continueGame) {
                    config.playerId = continueGame.id;
                    config.token = continueGame.token;
                    await UserService.getUserData();

                    if(config.nickname) {
                        this.mainMenuService.show(config.nickname);
                    } else {
                        const login = document.getElementById('login');
                        login.style.visibility = 'visible';
                    }
                } else if (user && user.userName) {
                    // LanguageService.currentData.currentLanguage = user.language;
                    LanguageService.changeHtmlLanguage();
                    LanguageService.changeGameLanguage();

                    const startScreen = document.getElementById('start_screen');
                    startScreen.style.visibility = 'hidden';
                    this.mainMenuService.show(user.userName);
                    config.guest = true;
                } else {
                    const startScreen = document.getElementById('start_screen');
                    //@ts-ignore
                    if (window.showGameRegistration === undefined) {
                        //@ts-ignore
                        window.showGameRegistration = false;
                        config.guest = true;
                    }
                    //@ts-ignore                    
                    if (!showGameRegistration) {
                        const login = document.getElementById('login');
                        login.style.visibility = 'visible';
                        config.guest = true;
                    } else {
                        startScreen.style.visibility = 'visible';
                    }
                    
                    const levels = MapConfig.elements;
                    LanguageService.init();
                    let isError = false;
                    user = {
                        userName: '',
                        revards: [],
                        score: 0,
                        id: '',
                        language: 'en',
                        level: 1,
                        tutorails: {
                            background_release: false,
                            fill_bar: false,
                            drop_product: false,
                        },
                        levels: {},
                        isMusicOn: true,
                    }

                    //@ts-ignore
                    if (isNeedToShowLoginAndRevard) {
                        user.mblnId = QueryService.userId;
                    }

                    for (let i = 0; i < levels.length; i++) {
                        const level = levels[i];
                        user.levels[level.level] = {
                            score: 0,
                            time: 0,
                            level: level.level,
                            isRevard: level.isRevard,
                        }

                        //@ts-ignore
                        if (level.isRevard && isNeedToShowLoginAndRevard) {
                            user.levels[`revard_${level.level}`] = {
                                score: 0,
                                time: 0,
                                level: level.level,
                                isRevard: true,
                                isRevardClimed: false,
                            }
                        }
                    }
              
                    let timer;
                    const error_msg = document.getElementById('error_msg');
                    const btn = document.getElementById('login_btn') as HTMLButtonElement;
                    userName.addEventListener('input', (e: any) => {
                        const filter = new Filter();
                        let value = e.target.value;
                        value = value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
                        userName.value = value;
                        if (filter.isProfane(value)) {
                            isError = true;
                            error_msg.style.display = 'flex';
                            userName.classList.add('error');
                            clearTimeout(timer);
                            timer = setTimeout(() => {
                                error_msg.style.display = 'none';
                                userName.classList.remove('error')
                            }, 5000)
                        } else {
                            isError = false;
                            clearTimeout(timer);
                            error_msg.style.display = 'none';
                            userName.classList.remove('error');
                        }
                    })
                    btn.addEventListener('click', async (e) => {
                        e.preventDefault();
                        PreloaderHelper.togglePreloader(true);
                        clearTimeout(timer);
                        if (userName.value.length > 3 && !isError) {
                            SoundService.stopAll();
                            user.userName = userName.value;
                            // await UserService.createUser(user).then((res) => {
                            //     btn.disabled = true;
                            //     error_msg.style.display = 'none';
                            //     userName.classList.remove('error')
                            //     user.id = res.id;
                            //     user.userName = userName.value;
                            //     user.language = LanguageStorage.language;
                            //     localStorage.setItem('mbny_game_user', JSON.stringify(user));
                            //     const login = document.getElementById('login');
                            //     login.style.visibility = 'hidden';

                            //     this.mainMenuService.show(user.userName);
                            // })
                            if(!config.guest) {
                                await UserService.saveNickName(userName.value);
                                btn.disabled = true;
                                error_msg.style.display = 'none';
                                userName.classList.remove('error');
                                user.id = config.playerId;
                                user.language = LanguageStorage.language;
                                localStorage.setItem('mbny_game_user', JSON.stringify(user));
                                const login = document.getElementById('login');
                                login.style.visibility = 'hidden';

                                this.mainMenuService.show(user.userName);                                
                            } else {
                                // await UserService.createUser(user).then((res) => {
                                    btn.disabled = true;
                                    error_msg.style.display = 'none';
                                    userName.classList.remove('error')
                                    user.id = config.gameId;
                                    user.userName = userName.value;
                                    user.language = LanguageStorage.language;
                                    localStorage.setItem('mbny_game_user', JSON.stringify(user));
                                    const login = document.getElementById('login');
                                    login.style.visibility = 'hidden';

                                    this.mainMenuService.show(user.userName);
                                // })
                            }
                            
                        } else {
                            PreloaderHelper.togglePreloader(false);
                            const error_msg = document.getElementById('error_msg');
                            error_msg.style.display = 'flex';
                            userName.classList.add('error')

                            timer = setTimeout(() => {
                                error_msg.style.display = 'none';
                                userName.classList.remove('error')
                            }, 5000)
                        }
                    })

                    const guestBtn = document.getElementById('guest_btn') as HTMLButtonElement;
                    guestBtn.addEventListener('click', async (e) => {
                        e.preventDefault();
                        PreloaderHelper.togglePreloader(true);
                        clearTimeout(timer);
                        
                        PreloaderHelper.togglePreloader(false);
                        config.guest = true;
                        startScreen.style.visibility = 'hidden';
                        const login = document.getElementById('login');
                        login.style.visibility = 'visible';
                        const gameId = Math.random().toString(26).slice(2);
                        config.gameId = `${gameId}`;
                    })
                    
                    const getStartedBtn = document.getElementById('startScreen_btn') as HTMLButtonElement;
                    getStartedBtn.addEventListener('click', async (e) => {
                        e.preventDefault();

                        startScreen.style.visibility = 'hidden';
                        this.signUpService.show();
                    })

                    const startScreenBtn = document.getElementById('start_logIn_btn') as HTMLButtonElement;
                    
                    startScreenBtn.addEventListener('click', async (e) => {
                        e.preventDefault();

                        startScreen.style.visibility = 'hidden';
                        this.signInService.show();
                    });
                }
            })
        })
    }

    // private async saveNickName(name: string) {
    //     const myHeaders = new Headers();
    //     myHeaders.append("Authorization", `Bearer ${config.token}`);
    //     myHeaders.append("Cookie", ".ASPXAUTH=E9DA9C13C33737ABF830ED77570064C1308550AD7E08E1BF15D19B8F358D21841390FF6BEEFC6DF8AE84FD8D917D2700F81F9812F13318CD189F1697C4681CC0BC4C3A9C304F699FF3E0EA0E44D92EAE71C01B8172ABF6126AE404922B358508F212408DACFEECDF45529D5B3BC4BB2425BE15DD92CC03E919BA56F4443A4A1DDD73F62423FD106411CBAE00572841D6C6BFCBBCC2E66CD15B9A44F56F73E35446DB0AD6; ASP.NET_SessionId=dg1xim41v5whmzv3abdqy1qo; SCAuth=4CC7FA71A96A1945984F0C50DE5C2EBA19676F16DD2B9B79631F80927BF8D54E41E54F427EC15B53ED75D249B504F40CF777E432D68C12A2EFAB9DEB7D8680FA5BE7AB36C5D4A6CCBBDEA0D31B84B2A2030C9D5FAF521423971F5DFBFAB7268D281A607B2FFE657FE1CAB6260233BACB3BBA54DDC0B265871836A1CF290D83A414A90F2BE7E53327D03E1F3E7A8ABCBAE9D294A8E293FDEA0866EF801EA795ED456422B0669E1F38D29659A9290FA2DAE76A885E5C1C5475EF3AEE5430A3A69442D62F6629DF501480B0D4226F3CC4D6008273BB; SC_ANALYTICS_GLOBAL_COOKIE=0d61d83a0a89495f8fdb9e2cc43b4df0|False; UserAuthentication=authenticated=yes&user_id=25eca36c-4c35-4095-8d8c-ce17b4550dfe&last_user_id=25eca36c-4c35-4095-8d8c-ce17b4550dfe&lg_key=73f4882d-7ff2-4d98-8cd7-b05f6ffc90db&geoIP=none; cookiesession1=678A3E0D898901234BCDEFGHIJKL234F; reinfo=0; sc_expview=0");

    //     const requestOptions = {
    //         method: 'PUT',
    //         headers: myHeaders,
    //         redirect: 'follow'
    //     };
    //     //@ts-ignore
    //     await fetch(`${config.path}/match-game/nickname?userId=${config.playerId}&nickname=${name}`, requestOptions)
    //         .then(response => response.text())
    //         .then(result => console.log(result))
    //         .catch(error => console.log('error', error));
    // }
}

new App();